.table {
  width: 100%;
  line-height: 1.5rem;
  border-spacing: unset;

  thead {
    font-size: var(--font-size-xs);
    color: var(--color-help-text);
  }

  th:not(:global(.bb-none)),
  td:not(:global(.bb-none)) {
    border-bottom: 1px solid var(--bg-gray-darkest);
  }

  th:not(:global(.text-align-r)) {
    text-align: left;
  }

  th[scope="col"] {
    height: 2.75rem;
    line-height: 1.125rem;
    padding: 0 1.5rem;

    &:global(.link-cell-padding) {
      padding-right: 4.5rem;
    }
  }

  th[scope="row"],
  td {
    height: 3.5rem;
    line-height: 1.25rem;
    padding: 0 1.5rem;

    &:global(.link-cell-padding) {
      padding-right: 4.5rem;
    }
  }

  /* Vertical center child inline-blocks */
  td > * {
    vertical-align: middle;
  }

  /* Gap between children */
  td > * + * {
    margin-left: 0.5rem;
  }

  td.numberCell {
    text-align: right;
    width: 6.5rem;
    line-height: 1.75rem;
    font-family: var(--font-number);
    font-feature-settings: "ss09" on;
  }

  td.integerCell {
    padding-right: 0;
    text-align: right;
  }

  td.fractionCell {
    padding-left: 0.5rem;
    text-align: left;
    font-size: var(--font-size-xs);
  }
  td.fractionCell:empty {
    width: 0;
    padding-left: 0;
  }

  tr.rowLink {
    cursor: pointer;

    &:hover {
      background: var(--color-hover);
    }

    /* Cell with the chevron icon */
    td:last-of-type {
      padding-right: 4.5rem;
      background-image: url("../../../assets/icons/chevronRight.svg");
      background-size: 1.25rem;
      background-position: center right 1.5rem;
      background-repeat: no-repeat;
    }
  }

  tr.downloadIcon {
    /* Replace the chevron icon with the download icon */
    td:last-of-type {
      background-image: url("../../../assets/icons/download.svg");
    }
  }

  tr.active {
    background: var(--gray-200);
  }

  tr.rowTotal {
    td {
      font-weight: bold;
      border-bottom: none;
    }
  }
}

/* Row header and first cell in the row large font, using `:where()` to give it lowest specificity */
:where(.table.defaultVariant th[scope="row"]),
:where(.table.defaultVariant td:first-child) {
  font-size: var(--font-size-lg);
}

.numberWidth {
  width: 6.5rem;
}
